import { render, staticRenderFns } from "./VLInfo.vue?vue&type=template&id=648b69c7&scoped=true"
import script from "./VLInfo.vue?vue&type=script&lang=js"
export * from "./VLInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b69c7",
  null
  
)

export default component.exports